import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from './pages.json';
import { structuredData, serializeStructuredData } from './structuredData';

export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, '') || '/';
    const canonical = config.aliases[path] || path;
    const page = config.pages[canonical];
    document.getElementById('page-structured-data')?.remove();
    if (!page) {
      document.title = 'Sidan hittades inte | Hälsinglands Multisport';
      document.querySelector('link[rel="canonical"]').href = config.origin + path;
      document.querySelector('meta[name="description"]').content = 'Sidan kunde inte hittas.';
      return;
    }
    const data = structuredData(canonical);
    if (data) {
      const script = document.createElement('script');
      script.id = 'page-structured-data';
      script.type = 'application/ld+json';
      script.textContent = serializeStructuredData(data);
      document.head.appendChild(script);
    }
    document.querySelector('meta[property="og:image"]').content = config.origin + page.image;
    document.querySelector('meta[property="og:image:alt"]').content = page.imageAlt;
    document.title = page.title;
    document.querySelector('meta[name="description"]').content = page.description;
    document.querySelector('meta[property="og:title"]').content = page.title;
    document.querySelector('meta[property="og:description"]').content = page.description;
    document.querySelector('meta[property="og:url"]').content = config.origin + canonical;
    document.querySelector('link[rel="canonical"]').href = config.origin + canonical;
  }, [pathname]);
  return null;
}
